const meta = {
  panels: 'Panels',
  customization: 'Customize',
  'query-traces': 'Query traces',
  'chronosphere-managed-dashboards': 'Chronosphere-managed dashboards',
  'classic-dashboards': 'Classic dashboards',
};

export default meta;
